import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {MonitorPO, PatentPO} from "@/model/product";
import {WritePatentForm} from "@/pages/Patent/WritePatent";
import {AssignItemsForm} from "@/widget/ProcessApproval/AssignProduct";
import {ContractPO} from "@/model/customer";
import {PaybackPO} from "@/model/finance";
import {UploadFileBO, UploadFileVO} from "@/service/common.s";

export enum PatentEnum {
    GetPatentPage = "/patent/getPatentPage",
    GetPatent = "/patent/getPatent",
    UpdatePatent = "/patent/updatePatent",
    CreatePatent = "/patent/createPatent",
    SyncPatent = "/patent/syncFile",
    SearchPatent = "/patent/searchPatent",
}

export interface PatentPageBO extends PaginationBO {
    keyword?: string;
    contractId?: number
}

export interface PatentPageVO extends ReviewStatusVO, PatentPO {
    instanceId?: number;
}

export interface PatentVO extends PatentPO {
    contract: ContractPO
    paybacks: PaybackPO[]
    monitors: MonitorPO[]
    contact: string
    mobile: string
}

export const useQueryPatentPage = (writeStatus: number) => useMutation({
    mutationFn: (data: PatentPageBO) => http.post<BaseVO<PaginationVO<PatentPageVO>>>({
        url: `${PatentEnum.GetPatentPage}/${writeStatus}`,
        data: data,
    }),
})

export interface AssignPatentBO {
    businessId: number
    executeId: string
    instanceId: number
    assignItems: AssignItemsForm
}

export interface SyncPatentExtraBO {
    category: string
    postDate:string
    rid: string
    categoryId: string
}

export interface SyncPatentBO {
    insideId: string
    applyNo: string
    isSave: number
    tag: number
    remark: string
    file: string
    extra: SyncPatentExtraBO
}

export interface SearchPatentBO {
    customerId?: number
}

export const useCreatePatent = () => useMutation({
    mutationFn: (data: WritePatentForm) => http.put({url: PatentEnum.CreatePatent, data}),
})

export const useUpdatePatent = () => useMutation({
    mutationFn: (data: WritePatentForm) => http.post({url: PatentEnum.UpdatePatent, data}),
})

export const useQueryPatent = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<PatentVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<PatentVO>>({
        url: PatentEnum.GetPatent,
        params: params
    }),
    enabled
})

export const useSearchPatent = () => useMutation({
    mutationFn: (data: SearchPatentBO) => http.post<BaseVO<PatentPO[]>>({
        url: PatentEnum.SearchPatent,
        data
    }),
})

export const useSyncPatent = () => useMutation({
    mutationFn: ({formData, onUploadProgress}: UploadFileBO) => http.post<BaseVO<UploadFileVO>>({
        url: PatentEnum.SyncPatent,
        headers: {
            "Content-Type": "multipart/form-data",
        }, onUploadProgress: event => {
            onUploadProgress(event)
        }, data: formData
    })
})



